// extracted by mini-css-extract-plugin
module.exports = {"main":"AvailabilityResult_main__3XlcI","filters":"AvailabilityResult_filters__3bfcr","hotels":"AvailabilityResult_hotels__mf2SK","hotel":"AvailabilityResult_hotel__3HLXS"};